import React, { useState } from 'react'
import './styles.scss'

export const ShowMoreButton = ({
  labels,
  current,
  toggle
}: {
  labels: { open: string; closed: string }
  current: boolean
  toggle: (e: boolean) => void
}) => {
  return (
    <button className='ShowMoreButton' onClick={() => toggle(!current)}>
      {current ? labels.open : labels.closed}
    </button>
  )
}
